import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitosuratcab() {



const cardData = {
  keyword: "Mumbai to Surat Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Surat cab services for travelers looking for a smooth and safe journey between Maharashtra and Gujarat. Whether you are planning a business trip, family visit, weekend getaway, or group travel, our cab service ensures a hassle-free ride with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Surat cab services.",

topPlaces: [
  {
    title: "Sardar Patel Museum",
    description:
      "Sardar Patel Museum in Surat showcases historical artifacts, ancient sculptures, and exhibits reflecting the region's cultural heritage. Visitors can enjoy educational tours, photography, and leisurely exploration of the museum halls. Traveling by cab ensures convenient and comfortable access from Mumbai, allowing sufficient time to explore the museum at leisure."
  },
  {
    title: "Dutch Garden",
    description:
      "Dutch Garden is a beautifully landscaped area featuring colonial-era tombs, lush greenery, and peaceful walking paths. Visitors can enjoy photography, relaxation, and historical insights. A cab ride provides easy access, allowing tourists to combine garden visits with other Surat attractions efficiently."
  },
  {
    title: "Dumas Beach",
    description:
      "Dumas Beach is a popular spot along the Arabian Sea, known for its black sand, calm waves, and sunset views. Visitors can enjoy leisurely walks, local snacks, and photography. Traveling by cab ensures a comfortable journey from Mumbai, making it easy to spend ample time exploring the beach and nearby attractions."
  },
  {
    title: "Surat Castle",
    description:
      "Surat Castle, a historic fort built in the 16th century, offers panoramic views of the city and the Tapi River. Visitors can explore fortifications, bastions, and historical architecture. A cab service allows convenient access, ensuring tourists can plan their sightseeing efficiently."
  },
  {
    title: "Gopi Talav",
    description:
      "Gopi Talav is a scenic lake surrounded by gardens and walking paths, perfect for relaxing strolls and photography. Visitors can enjoy local food from nearby stalls and spend time amidst tranquil surroundings. Traveling by cab ensures comfortable transport, making it easy to include the lake in a full day of sightseeing."
  },
  {
    title: "Chintamani Jain Temple",
    description:
      "Chintamani Jain Temple is an intricately carved temple dedicated to Lord Mahavir, reflecting exquisite architecture and spiritual significance. Visitors can perform rituals, enjoy peaceful surroundings, and capture photography. A cab ride provides convenient access from Mumbai, allowing enough time for exploration and religious visits."
  },
  {
    title: "Ambika Niketan Temple",
    description:
      "Ambika Niketan Temple is a prominent religious site in Surat, attracting devotees for prayers and rituals. Visitors can experience the peaceful environment and traditional architecture. Traveling by cab ensures safe and hassle-free access for a spiritual and cultural experience."
  },
  {
    title: "Science Centre",
    description:
      "Surat Science Centre offers interactive exhibits, planetarium shows, and educational activities for families and students. Visitors can enjoy hands-on learning and explore scientific displays. A cab ride provides convenient travel from Mumbai, making it easy to include the Science Centre in a full-day itinerary."
  },
  {
    title: "VR Surat Mall",
    description:
      "VR Surat Mall is a modern shopping and entertainment hub, featuring retail stores, food courts, and cinema options. Visitors can shop, dine, and enjoy recreational activities. Traveling by cab allows hassle-free access, enabling tourists to combine shopping with sightseeing comfortably."
  },
  {
    title: "Cambridge Tower and Cityscape Viewpoints",
    description:
      "Visitors can explore Cambridge Tower and nearby viewpoints for panoramic views of Surat city and the Tapi River. Photography enthusiasts and nature lovers will enjoy the scenic vistas. Using a cab ensures easy and comfortable travel, allowing tourists to plan multiple sightseeing spots efficiently."
  }
],




services: [
{
name: "Mumbai to Surat Cab",
description: "Mumbai to Surat cab service provides comfortable and reliable intercity travel between Mumbai and the major commercial city of Surat. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway journeys along NH-48. Professional drivers with strong route knowledge ensure safe and timely travel. Pickup is available from homes, hotels, offices, railway stations, and Mumbai airport terminals. This service is ideal for business trips, family travel, and corporate visits. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient trip planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Surat Taxi",
description: "Mumbai to Surat taxi service offers convenient transportation for travelers visiting Gujarat’s major business hub. Comfortable AC vehicles ensure pleasant long-distance travel along well-connected highway routes. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and Mumbai airport terminals. Ideal for business travelers, families, and tourists planning intercity travel. Clean interiors and spacious seating provide comfortable journeys. Flexible departure schedules help passengers plan trips easily. Reliable taxi services ensure safe and efficient travel."
},
{
name: "Mumbai to Surat Cab Service",
description: "Mumbai to Surat cab service provides dependable road transportation for passengers planning long-distance journeys. Our well-maintained AC vehicles ensure smooth highway travel and comfortable seating. Professional drivers ensure safe driving along the Mumbai–Surat route. Pickup services are available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, family visits, and outstation trips. Spacious vehicles provide comfortable seating for extended journeys. Flexible booking options allow travelers to schedule trips conveniently. Transparent pricing ensures reliable cab service."
},
{
name: "Mumbai to Surat Taxi Service",
description: "Mumbai to Surat taxi service offers efficient and comfortable road travel between two major commercial cities. Our fleet of AC vehicles ensures relaxed travel conditions throughout the journey. Skilled drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for business meetings, corporate travel, and family visits. Spacious seating ensures passenger comfort during long-distance travel. Flexible booking options allow convenient scheduling. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Surat",
description: "Cab from Mumbai to Surat offers private and comfortable transportation for passengers traveling between Maharashtra and Gujarat. Our AC vehicles ensure smooth highway journeys and pleasant travel experiences. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, family visits, and business trips. Spacious interiors ensure relaxed seating for passengers. Flexible departure timing allows convenient trip planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Surat",
description: "Taxi from Mumbai to Surat provides dependable transportation for travelers seeking comfortable road journeys. AC vehicles ensure pleasant travel across highways connecting the two cities. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, tourists, and business travelers. Clean interiors and spacious seating ensure passenger comfort. Flexible scheduling options allow easy travel planning. Professional taxi services ensure reliable intercity travel."
},
{
name: "Mumbai to Surat Cab Booking",
description: "Mumbai to Surat cab booking allows travelers to reserve vehicles easily for intercity journeys. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel and family trips. Flexible one-way and round-trip booking options are available. Reliable booking service ensures hassle-free travel planning."
},
{
name: "Mumbai to Surat Taxi Booking Online",
description: "Mumbai to Surat taxi booking online provides quick and convenient reservations for passengers planning long-distance travel. Instant booking confirmation allows travelers to schedule trips without delays. Comfortable AC vehicles ensure relaxed highway journeys. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travelers and families. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Surat Cab Price",
description: "Mumbai to Surat cab price offers affordable and transparent travel options for passengers planning intercity journeys. Clear pricing helps travelers understand trip costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel throughout the journey. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Surat Taxi Fare",
description: "Mumbai to Surat taxi fare is calculated using transparent per-kilometer pricing to provide clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth highway travel between the two cities. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for family travel and business trips. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Surat One Way Cab",
description: "Mumbai to Surat one way cab service is perfect for travelers who require drop service without paying return charges. This option helps reduce travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance highway travel. Professional drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel and personal visits. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
},
{
name: "Mumbai to Surat Round Trip Taxi",
description: "Mumbai to Surat round trip taxi service offers complete travel convenience for passengers planning return journeys. Flexible return timing allows travelers to complete business meetings or visits comfortably. Comfortable AC vehicles ensure relaxed travel during the entire journey. Professional drivers remain available for return travel according to passenger schedules. Pickup services are available across Mumbai including homes, hotels, and airport terminals. Ideal for corporate travel and family visits. Spacious vehicles ensure comfortable travel for groups. Reliable round-trip taxi service ensures smooth travel planning."
},
{
name: "Mumbai to Surat Innova Cab",
description: "Mumbai to Surat Innova cab service provides spacious and comfortable travel for families and group travelers. The premium MPV offers ample seating space and luggage capacity for long-distance journeys. AC interiors ensure pleasant travel conditions throughout the trip. Experienced drivers ensure safe highway driving along the Mumbai–Surat route. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for corporate teams and family travel. Comfortable seating ensures relaxed travel for passengers. Reliable Innova cab service ensures convenient intercity travel."
}
],

tableData: [
["Mumbai to Surat Cab","Mumbai to Surat Taxi"],
["Mumbai to Surat Cab Service","Mumbai to Surat Taxi Service"],
["Cab from Mumbai to Surat","Taxi from Mumbai to Surat"],
["Mumbai to Surat Cab Booking","Mumbai to Surat Taxi Booking Online"],
["Mumbai to Surat Cab Price","Mumbai to Surat Taxi Fare"],
["Mumbai to Surat One Way Cab","Mumbai to Surat Round Trip Taxi"],
["Mumbai to Surat Innova Cab","Best Cab Mumbai to Surat"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai to Surat highway route via NH48. They understand the traffic patterns, toll plazas, and best routes between Maharashtra and Gujarat, ensuring a safe and smooth long-distance journey."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Surat cab bookings. We clearly explain per-kilometer rates, toll charges, and travel packages before booking so customers never face hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel early morning or late at night, Omshree Cabs provides 24/7 cab booking and customer support for your Mumbai to Surat journey."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures a comfortable and relaxing ride for long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible travel plans including one-way cabs, round trips, and same-day return packages. Travelers can customize their trip schedule according to their travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Surat begins smoothly."
  },
  {
    WhyChooseheading: "Reliable Intercity Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Surat trips. Our punctual service, professional drivers, and comfortable vehicles ensure a smooth and reliable intercity travel experience."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Surat by cab?", answer: "The distance from Mumbai to Surat is approximately 280 km and the journey usually takes around 5–6 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Surat cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Surat." },
  { question: "Which vehicles are available for Mumbai to Surat travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Surat cab bookings." },
  { question: "Can we stop during the journey for meals or rest?", answer: "Yes, passengers can request stops during the journey for food, refreshments, or rest breaks." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you offer same-day return packages?", answer: "Yes, same-day return cab packages from Mumbai to Surat are available depending on travel schedule." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and peak travel seasons." },
  { question: "Do you provide corporate travel services to Surat?", answer: "Yes, Omshree Cabs also provides corporate and business travel services for Mumbai to Surat routes." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Surat business trip. The driver was punctual and the car was very clean and comfortable for the long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback:
      "Our family trip from Mumbai to Surat with Omshree Cabs was excellent. Smooth driving, transparent pricing, and professional service made the journey very comfortable.",
    rating: 5
  }
];






















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Surat Cab",
  "description": "Book Mumbai to Surat Cab with Omshree Cab for safe and comfortable outstation travel. Choose from Innova and other cabs for one-way or round trips. Affordable fares, easy online cab booking, and reliable taxi service from Mumbai to Surat.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2400"
  }
};



  return (
    <div>
      

<Helmet>
  <title>Mumbai to Surat Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Surat Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Surat with Innova and other cabs for one-way or round trips. Affordable fares and easy online cab booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosuratcab;